function PgLogLevel() {
    return {
        restrict: 'E',
        scope: {
            level: '=level'
        },
        templateUrl: '/partials/controls/PaymentGateway/pg-log-level.html'
    };
}
